import { httpJump } from './httpJump';

export type ToJumpRedirectResponse = {
  redirect_url: string;
  token: string;
  expires_at: string;
};

export function generateToJumpRedirect(params: {
  bitrix_user_id: number | string;
  task_id: number | string;
}) {
  return httpJump.post<ToJumpRedirectResponse>(
    '/to_jump/api/redirect/generate',
    {
      bitrix_user_id: String(params.bitrix_user_id),
      task_id: String(params.task_id),
    }
  );
}

export function disconnectJumpSessions(params: { task_id: number | string }) {
  return httpJump.post('/to_jump/api/webhooks/disconnect-sessions', {
    task_id: String(params.task_id),
  });
}
